import * as React from 'react';

import { Loader } from '@App/bundles/common/components'
import { PhotoGrid } from '.'

// import { PhotoData } from '@App/common/data/photoData'
// import { CustomPhoto, PhotoListModel } from '@App/common/models'
// import { PhotoListModel } from '@App/common/models'
import {  } from '@App/common/models/customPhoto.mdl'

import './photoContainer.css';

export interface IPhotoContainerProps {
  page: string,
  loaded: boolean
}

export interface IPhotoContainerState {
  gridLoaded: boolean,
  showLoader: boolean
}

export default class IPhotoContainer extends React.PureComponent<IPhotoContainerProps, IPhotoContainerState> {
  // private loadingTimer: any;
  // private hastimer: boolean = false; 

  constructor(props: IPhotoContainerProps){
    super(props);

    this.state = {
      gridLoaded: this.props.loaded,
      showLoader: false
    }

    this.getClass = this.getClass.bind(this);
    this.hideCurtain = this.hideCurtain.bind(this);
  }

  public hideCurtain(){
    console.log('hide curtain')
    this.setState({ gridLoaded: true });
  }

  // public getShowLoader(){
  //   this.loadingTimer = setInterval(() => {
  //     if ( !this.state.gridLoaded && !this.hastimer) {
  //       this.hastimer = true;
  //       this.setState({ showLoader: true });
  //     } else if ( this.state.gridLoaded && this.state.showLoader ) {
  //       clearInterval(this.loadingTimer);
  //       this.hastimer = false;
  //       this.setState({ showLoader: false });
  //     } else {
  //       console.log('here');
  //       this.hastimer = false;
  //       clearInterval(this.loadingTimer);
  //     }
  //   }, 2000);
  // }

  public getClass(){
    if(this.state.gridLoaded) {
      return "fade-out";
    } else {
      return "hide";
    }
    // return (this.state.gridLoaded) ? "cover-grid hide" : "cover-grid fade-out";
  }

  public getLoaderClass(){
    return (this.state.gridLoaded) ? 'hide' : 'show-loader';
  }

  public showLoader(){
    return (this.state.gridLoaded) ? false : true;
  }

  public render() {
    // this.getShowLoader();

    return (
      <div>
          { this.showLoader() &&
            
            <div className={this.getLoaderClass()} style={{ height: 10, width: 10 }}>
              <Loader />
            </div>
          }
        <div className={ this.getClass() }>
          <PhotoGrid page={ this.props.page } hider={ this.hideCurtain }/>
        </div>
      </div>
    );
  }

  // public componentDidMount(){
  //   console.log('getShowLoader')
  //   this.getShowLoader()
  // }
  public componentDidUpdate(prevProps: IPhotoContainerProps, prevState: IPhotoContainerState, snapshot: any){
    if(prevProps.page !== this.props.page){
      this.setState({gridLoaded: false})
      // this.getShowLoader();
    }
  }
}



// WEBPACK FOOTER //
// ./src/bundles/photogrid/components/photoContainer.tsx